export default __webpack_public_path__ + "static/media/about_us_car_nima_sarram.bf68b965.png";